module.exports = __webpack_public_path__ + "img/8.4d7f3091.png";